<template>
  <navbar navbar-menu-classes="navbar-right bg-primary" v-model="showMenu">
    <div class="navbar-wrapper">
      <a class="navbar-brand" href="#">Tactical Bitcoin</a>
    </div>
    <template slot="navbar-menu">
      <router-link :to="{name: 'AdminLogin'}" class="nav-item" tag="li">
        <a class="nav-link">
          Admin Login
        </a>
      </router-link>
      <router-link :to="{name: 'UserLogin'}" class="nav-item" tag="li">
        <a class="nav-link">
          User Login
        </a>
      </router-link>
      <!-- <router-link to="/register" class="nav-item" tag="li">
        <a class="nav-link">
         Partner
        </a>
      </router-link>
      <router-link to="/login" class="nav-item" tag="li">
        <a class="nav-link">
         Contact
        </a>
      </router-link> -->

    </template>
  </navbar>
</template>

<script>
  import { Navbar } from 'src/components/UIComponents';
  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    data() {
      return {
        showMenu: false
      }
    }
  }
</script>

<style scoped></style>
